export interface UserWarehouse {
  WarehouseCode: string;
  Title: string;
}
